import { Button, InputAdornment, TextField } from "@mui/material";
import { IoIosMail } from "react-icons/io";
import { useForm } from "react-hook-form";
import { resetPasswordFn } from "../api/reset-password";
import { PiLockKeyFill } from "react-icons/pi";
import { useNavigate, useParams } from "react-router-dom";
import toast from "components/Elements/Toast/Toast";
import { IoArrowBack } from "react-icons/io5";
import { MdVerified } from "react-icons/md";

type ResetPasswordProps = {
  onSuccess: () => void;
};

export const ResetPasswordForm = ({ onSuccess }: ResetPasswordProps) => {
  const { code } = useParams();

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const handleResetPW = (data: any) => {
    resetPasswordFn(data, (response: any) => {
      if (response.status === "OK") {
        onSuccess();
        toast.success("Succesfully Changed Password");
      } else {
        setError("root.serverError", {
          type: "server",
          message: response.response?.data?.notes,
        });
      }
    });
  };

  return (
    <form onSubmit={handleSubmit(handleResetPW)}>
      <h1 className="details-wrapper-title rounded-sm">Reset Password</h1>
      <div className="flex flex-col w-full gap-4 mt-2">
        <TextField
          type="email"
          label="Email"
          variant="filled"
          error={errors.email ? true : false}
          helperText={errors.email && "Email is required"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IoIosMail />
              </InputAdornment>
            ),
          }}
          {...register("email", { required: true })}
        />

        <TextField
          type="text"
          label="Verification Code"
          variant="filled"
          defaultValue={code}
          error={errors.code ? true : false}
          helperText={errors.code && "Verification Code is required"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <MdVerified />
              </InputAdornment>
            ),
          }}
          {...register("code", { required: true })}
        />

        <TextField
          type="password"
          label="New Password"
          variant="filled"
          error={errors.password1 ? true : false}
          helperText={errors.password1 && "Password is required"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PiLockKeyFill />
              </InputAdornment>
            ),
          }}
          {...register("password1", { required: true })}
        />

        <TextField
          type="password"
          label="Confirm New Password"
          variant="filled"
          error={errors.password2 ? true : false}
          helperText={errors.password2 && "Password is required"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PiLockKeyFill />
              </InputAdornment>
            ),
          }}
          {...register("password2", { required: true })}
        />

        <h2 className="text-red-500 flex justify-end">
          {errors.root?.serverError?.message}
        </h2>
        <div className="items-center flex flex-row justify-end">
          <Button
            className="!text-2xl text-white !mr-4"
            variant="contained"
            color="info"
            type="submit"
            onClick={() => navigate("/auth/login")}
            startIcon={<IoArrowBack />}
          >
            Back
          </Button>
          <Button
            className="!text-2xl text-white"
            variant="contained"
            type="submit"
            color="secondary"
          >
            Submit
          </Button>
        </div>
      </div>
    </form>
  );
};
